var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1611 0.495143L25.5123 2.85168C26.1626 3.50349 26.1626 4.55641 25.5123 5.20821L18.3422 12.4115V26.573C18.3422 27.6776 17.4467 28.573 16.3422 28.573H2C0.89543 28.573 0 27.6776 0 26.573V5.50349C0 4.39892 0.89543 3.50349 2 3.50349H17.7919L20.7933 0.495143C21.4603 -0.156665 22.5108 -0.173378 23.1611 0.495143ZM13.7233 14.6678L22.6776 5.7096L20.3098 3.33636L11.3721 12.3112L10.1882 15.8544L13.7233 14.6678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIcon);
export default __webpack_public_path__ + "static/media/article-icon.61207f46e20d9e00acdbca64a09ff27f.svg";
export { ForwardRef as ReactComponent };